import { render, staticRenderFns } from "./PaidGrantRuleEdit.vue?vue&type=template&id=1299c091&scoped=true&"
import script from "./PaidGrantRuleEdit.vue?vue&type=script&lang=js&"
export * from "./PaidGrantRuleEdit.vue?vue&type=script&lang=js&"
import style0 from "./PaidGrantRuleEdit.vue?vue&type=style&index=0&id=1299c091&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1299c091",
  null
  
)

export default component.exports